import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.config({ autoRefreshEvents: "visibilitychange,DOMContentLoaded,load, resize" });

export function initWhyWaterTechBanner() {
  if (!document.querySelector('.tif-module-why-water-tech-banner')) return;

  ScrollTrigger.create({
    trigger: '.start-trig',
    pin: '.bg-wrap',
    pinSpacing: true,
    start: "top 100px",
    endTrigger: '.last',
    end: 'bottom bottom',
    scrub: true,
  });

  const heading = document.querySelector('.tif-module-why-water-tech-banner .heading');
  const block1 = document.querySelector('.tif-module-why-water-tech-banner .block-1');
  const block2 = document.querySelector('.tif-module-why-water-tech-banner .block-2');

  // Create waypoint-like scroll triggers
  if (heading) {
    ScrollTrigger.create({
      trigger: '#holdone',
      start: 'top top',
      onEnter: () => heading.classList.add('active'),
      onLeaveBack: () => heading.classList.remove('active'),
    });
  }

  if (block1) {
    ScrollTrigger.create({
      trigger: '.tif-module-why-water-tech-banner .heading',
      start: 'top top',
      onEnter: () => block1.classList.add('active'),
      onLeaveBack: () => block1.classList.remove('active'),
    });
  }

  if (block2) {
    ScrollTrigger.create({
      trigger: '.tif-module-why-water-tech-banner .block-1',
      start: 'top 50px',
      onEnter: () => block2.classList.add('active'),
      onLeaveBack: () => block2.classList.remove('active'),
    });
  }
}
